// TODO(NZTAJP-583): remove with UseNewPlacesApi flag — entire file is removed when the flag is.
// Reads the SSR-rendered data-use-new-places-api attribute on #root to decide which Places API path renders.
export function isNewPlacesApiEnabled(): boolean {
  return document.getElementById('root')?.dataset?.useNewPlacesApi === 'true'
}
